<app-settingwindow [title]="'Progetti'" (onClose)="closeModal()" (onSave)="save()">
    <ul class="nav nav-tabs" id="myTab" role="tablist">        
        <li class="nav-item ">
            <a class="nav-link" [class.active]="tab=='2'" (click)="tab='2'" >Importazione</a>
        </li>
        <!--
        <li class="nav-item ">
            <a class="nav-link" [class.active]="tab=='1'" (click)="tab='1'" >Altro (Plugins)</a>
        </li>
        -->
    </ul>
    <div class="p-2" >
        <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" *ngIf="tab=='1'">                
                <settingwindow-listplugins [type]="'project'" [plugins]="plugins"></settingwindow-listplugins>                   
            </div>
            <div class="tab-pane fade show active" *ngIf="tab=='2'">
                <app-importer [table]="'project'" [modulename]="'project'"></app-importer>
            </div>
        </div>
    </div>
</app-settingwindow>